import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="container">
        <div className="not-found-content">
          <div className="not-found-visual">
            <h1 className="not-found-number">404</h1>
            <div className="not-found-illustration">
              <div className="illustration-circle"></div>
              <div className="illustration-circle"></div>
              <div className="illustration-circle"></div>
            </div>
          </div>
          
          <div className="not-found-text">
            <h2 className="not-found-title">Página no encontrada</h2>
            <p className="not-found-description">
              Lo sentimos, la página que estás buscando no existe o ha sido movida.
            </p>
            
            <div className="not-found-actions">
              <Link to="/" className="btn btn-primary btn-lg">
                Volver al inicio
              </Link>
              <Link to="/contact" className="btn btn-outline btn-lg">
                Contactar
              </Link>
            </div>
            
            <div className="not-found-links">
              <p>O visita estas páginas:</p>
              <ul>
                <li><Link to="/">Inicio</Link></li>
                <li><Link to="/about">Sobre Nosotros</Link></li>
                <li><Link to="/contact">Contacto</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
